module.exports = __webpack_public_path__ + "img/link-handbook-mobile_jp.e147db7.jpg";